import { buttonVariants } from '@plato/ui-legacy/components/ui/button';
import { cn } from '@plato/ui/util/classes';
import { ArrowUpRightIcon } from 'lucide-react';

type Props = {
    className?: string;
};

export function ShowMoreArrow({ className }: Props) {
    return (
        <span
            aria-hidden
            className={cn(buttonVariants({ variant: 'card' }), 'absolute right-2 top-2', className)}
        >
            <ArrowUpRightIcon className="h-4 w-4 shrink-0" />
        </span>
    );
}
